var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{staticClass:"btn-back position-absolute right-100 px-0 mr-1 rounded border-0",on:{"click":function($event){return _vm.goBack()}}},[_c('b-icon',{attrs:{"icon":"arrow-left","aria-hidden":"true"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }